import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "13",
  height: "11",
  viewBox: "0 0 13 11",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M11.9956 2.0365C12.2671 1.75421 12.2671 1.29532 11.9956 1.01304C11.7247 0.730029 11.2851 0.730029 11.0136 1.01304L3.68422 8.65207L1.38484 6.25628C1.114 5.97327 0.673712 5.97327 0.40287 6.25628C0.131335 6.53928 0.131335 6.99745 0.40287 7.27974L3.15851 10.1525C3.16962 10.1648 3.18003 10.1771 3.19184 10.1887C3.32726 10.3306 3.50504 10.4008 3.68283 10.4008C3.71616 10.4008 3.7495 10.3986 3.78283 10.3935C3.92658 10.3726 4.06548 10.3045 4.1759 10.1887C4.1877 10.1771 4.19881 10.1648 4.20923 10.1518L11.9956 2.0365Z",
  fill: "#56AF40"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3))
}
export default { render };